<template>
  <div>
    <InfoDialog
      title="Post a job opportunity on the platform and partner with Riverflex to earn 40% margin share!"
      content-class="share-opp-rewards-dialog"
      :show="show"
      :content-style="contentStyle"
      @hide="handleDialogHide"
    >
      <div>
        <ul class="reset-list">
          <li>
            <strong>Step 1:</strong> Post a job opportunity on the
            <router-link to="/opportunities">
              Opportunities
            </router-link>&nbsp;page and Request support from Riverflex by sending an email to Derek at
            <a
              href="mailto:derek.vanderschyff@riverflex.com"
              @click="handleSupportEmailClick"
            >
              derek.vanderschyff@riverflex.com
            </a>
          </li>
          <li>
            <strong>Step 2:</strong> Your job opportunity will be visible to our network of high-quality consultants on the platform.
          </li>
          <li>
            <strong>Step 3:</strong> We will be in touch to partner with you and give you our full support to find the best independent consultants for the project and help you staff it.
          </li>
          <li>
            <strong>Step 4:</strong> When the opportunity has been successfully staffed, you will receive 40% margin share.
          </li>
        </ul>
        <p class="mt-2">
          <i>*40% margin share valid until 31st  December 2020, T’s & C’s apply.</i>
        </p>
        <div class="text-center">
          <v-btn
            class="mt-3"
            color="primary"
            rounded
            light
            @click="handlePostOppClick"
          >
            Post a job opportunity
          </v-btn>
        </div>
      </div>
    </InfoDialog>
    <v-dialog
      v-model="showCreateDialog"
      fullscreen
      persistent
      transition="dialog-bottom-transition-10"
    >
      <createOpportunity
        @hide="showCreateDialog = false"
        @submitOpp="submitOpp"
      />
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import InfoDialog from '@/components/core/InfoDialog.vue'
import createOpportunity from '@/components/opportunities/createOpportunity.vue'
import { waitAsync } from '@/utils/common'
import { MODAL_TRANSITION_TIME } from '@/constants'
import { shareOppRewardEvents } from '@/segmentAnalytics/rewards'

@Component({
  components: {
    InfoDialog,
    createOpportunity
  }
})
export default class ShareOppRewardsDialog extends Vue {
  @Prop({ required: true }) show: boolean
  @Prop() contentStyle: string
  
  showCreateDialog: boolean = false

  handlePostOppClick () {
    shareOppRewardEvents.trackPostJob()
    this.showCreateDialog = true
  }

  handleDialogHide () {
    shareOppRewardEvents.trackClose()
    this.$emit('hide')
  }

  handleSupportEmailClick () {
    shareOppRewardEvents.trackEmailForSupport()
  }

  async submitOpp (input: any) {
    this.showCreateDialog = false
    await waitAsync(MODAL_TRANSITION_TIME)
    this.$store.dispatch('upsertOpportunity', input)
  }
}
</script>
<style lang='scss'>
.share-opp-rewards-dialog {
  &.v-card,
  .v-btn.v-btn--icon,
  a {
    color: #fff !important;
  }

  .info-icon {
    background-image: none;
    background-color: #fff;
    color: #8E59FF;
  }
}
</style>
